import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import { useAuthToken } from '../contexts/AuthTokenContext';
import styles from './ProfileButton.module.css';

export default function ProfileButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useAuthToken();

  // Don't show on login/register pages
  const hiddenRoutes = ['/login', '/register', '/forgot-password', '/verify-email'];
  const isHidden = hiddenRoutes.includes(location.pathname);

  if (!token || isHidden) return null;

  return (
    <button
      className={styles.profileButton}
      onClick={() => navigate('/profile')}
      aria-label="Go to profile"
    >
      <FaUserCircle size={40} />
    </button>
  );
}
